import React, { useState, useEffect } from 'react';
import { Select, Tag, Spin, Alert } from 'antd';
import api from '../../../services/api';
import debounce from 'lodash/debounce';

const { Option } = Select;

function SearchArmador({ value = [], onChange = () => { } }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('filters/armadores');
      const armadores = response.data.map(item => ({
        label: item.name,
        value: item.idArmador
      }));
      const optionsWithTodos = [{ label: 'TODOS', value: 'todos' }, ...armadores];
      setOptions(optionsWithTodos);
    } catch (err) {
      console.error('Error fetching options:', err);
      setError('Erro ao buscar opções');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const handleChange = (selectedValues) => {
    let newValue = selectedValues;

    if (newValue.includes('todos')) {
      newValue = ['todos'];
    } else {
      newValue = newValue.filter(item => item !== 'todos');
    }

    onChange(newValue);
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const option = options.find(opt => opt.value === value);
    const displayLabel = option ? option.label : label;

    return (
      <Tag closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
        {displayLabel}
      </Tag>
    );
  };

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Select carriers or suppliers"
      value={value}
      onChange={handleChange}
      loading={loading}
      tagRender={tagRender}
      rules={[{ required: true, message: 'Please select at least one carrier or supplier' }]}
      onFocus={fetchOptions}
      notFoundContent={loading ? <Spin size="small" /> : null}
    >
      {options.map(option => (
        <Option
          key={option.value}
          value={option.value}
          disabled={value.includes('todos') && option.value !== 'todos'}
        >
          {option.label}
        </Option>
      ))}
      {error && (
        <Option disabled>
          <Alert message={error} type="error" showIcon />
        </Option>
      )}
    </Select>
  );
}

export default SearchArmador;